module.exports = __webpack_public_path__ + "teamwork-logo.png";


//////////////////
// WEBPACK FOOTER
// ./images/integrations/teamwork-logo.png
// module id = 1269
// module chunks = 74